import pkceChallenge from "pkce-challenge";
import {
  GetTokenRequestBody,
  GetTokenResponseBody,
} from "../../models/gygia/gygia.model";

const generateCodeVerifierAndChallenge = async () => await pkceChallenge();
const gygiaURL = `${window.location.host}/user`;
const DOMAIN = window.location.origin;
const LOGOUT_GIGYA_URL = process.env.REACT_APP_LOGOUT_GIGYA_URL
  ? `${DOMAIN}${process.env.REACT_APP_LOGOUT_GIGYA_URL}`
  : "";

const getToken = async (
  requestBody: GetTokenRequestBody,
): Promise<GetTokenResponseBody> => {
  const urlEncodedBody = new URLSearchParams();

  for (const [key, value] of Object.entries(requestBody)) {
    urlEncodedBody.append(key, value);
  }

  return fetch(`${gygiaURL}/token`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(urlEncodedBody).toString(),
  }).then((data) => data.json());
};

const logoutGygia = async (): Promise<void> => {
  const url = `${LOGOUT_GIGYA_URL}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
      mode: "cors",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
    });

    if (!response.ok) throw new Error(`Error: ${response.status}`);
    const data = await response.json();

    window.location.href = data.logoutUrl;
  } catch (error) {
    console.error("GET AUTH Request Failed:", error);
  }
};

const getTokenRequestBody = (
  token: string,
  grantType: string,
  codeVerifier?: string,
): GetTokenRequestBody => {
  const isRefreshToken = grantType === "refresh_token";

  return {
    grant_type: grantType,
    ...(isRefreshToken ? { refresh_token: token } : { code: token }),
    ...(!isRefreshToken && {
      redirect_uri: "https://d1jn76xkuksilt.cloudfront.net/",
      code_verifier: codeVerifier,
    }),
    client_id: process.env.REACT_APP_CLIENT_ID!,
  };
};

export {
  generateCodeVerifierAndChallenge,
  getToken,
  getTokenRequestBody,
  logoutGygia,
};
